import { TypographySize, TypographySizeParams } from './types';

const caption = {
    caption1: {
        size: '12px',
        lineHeight: '16px',
        weight: '400',
        tag: 'span',
    },
} as const;

const button = {
    button1: {
        size: '16px',
        lineHeight: '24px',
        weight: '500',
        tag: 'span',
    },
    button2: {
        size: '14px',
        lineHeight: '16px',
        weight: '500',
        tag: 'span',
    },
} as const;

const additional = {
    body1_long: {
        size: '16px',
        lineHeight: '24px',
        weight: '400',
        tag: 'span',
    },
    body1_short: {
        size: '16px',
        lineHeight: '20px',
        weight: '400',
        tag: 'span',
    },
    body2_long: {
        size: '14px',
        lineHeight: '20px',
        weight: '400',
        tag: 'span',
    },
    body2_short: {
        size: '14px',
        lineHeight: '16px',
        weight: '400',
        tag: 'span',
    },
} as const;

const subtitles = {
    subtitle1: {
        size: '18px',
        lineHeight: '24px',
        weight: '400',
        tag: 'span',
    },
    subtitle2: {
        size: '16px',
        lineHeight: '24px',
        weight: '500',
        tag: 'span',
    },
    subtitle3: {
        size: '14px',
        lineHeight: '20px',
        weight: '500',
        tag: 'span',
    },
} as const;

export const mainFonts = {
    hl1: {
        size: '72px',
        lineHeight: '80px',
        weight: '500',
        tag: 'h1',
    },
    hl2: {
        size: '56px',
        lineHeight: '64px',
        weight: '500',
        tag: 'h2',
    },
    hl3: {
        size: '48px',
        lineHeight: '56px',
        weight: '500',
        tag: 'h3',
    },
    h1: {
        size: '40px',
        lineHeight: '48px',
        weight: '500',
        tag: 'h1',
    },
    h2: {
        size: '34px',
        lineHeight: '40px',
        weight: '500',
        tag: 'h2',
    },
    h3: {
        size: '28px',
        lineHeight: '36px',
        weight: '500',
        tag: 'h3',
    },
    h4: {
        size: '24px',
        lineHeight: '32px',
        weight: '500',
        tag: 'h4',
    },
    h5: {
        size: '20px',
        lineHeight: '28px',
        weight: '500',
        tag: 'h5',
    },
    h6: {
        size: '18px',
        lineHeight: '24px',
        weight: '500',
        tag: 'h6',
    },
} as const;

export const typographySizes: Record<TypographySize, TypographySizeParams> = {
    ...caption,
    ...button,
    ...additional,
    ...subtitles,
    ...mainFonts,
};
